import './_easings'
import { setPosTop, resetPosTop } from './posTop'

export function trigger() {
  const navTrigger = document.querySelector('.js-nav-trigger')
  if (navTrigger) {
    navTrigger.addEventListener('click', function (e) {
      if (!document.body.classList.contains('is-nav-active')) {
        setPosTop()
        document.body.classList.add('is-nav-active')
        window.scrollTo(0, 0)
      } else {
        document.body.classList.remove('is-nav-active')
        resetPosTop()
      }
      e.preventDefault()
    })
  }

  const close = document.querySelectorAll('.js-trigger-close')
  if (close) {
    for (let i = 0; i < close.length; i++) {
      const el = close[i]
      el.addEventListener('click', function (e) {
        document.body.classList.remove('is-nav-active')
        resetPosTop()
        e.preventDefault()
      })
    }
  }
}
